const seo = {
  fr: {
    '/': {
      title: 'GPE – Énergies & Services | Installations électriques et énergies renouvelables',
      description:
        'GPE – Énergies & Services accompagne les entreprises dans leurs projets électriques, énergies renouvelables, CVC, mobilité électrique, VRD et études techniques.',
    },

    '/about': {
      title: 'À propos de GPE – Énergies & Services',
      description:
        'Découvrez GPE – Énergies & Services, notre expertise, nos équipes et notre savoir-faire dans les installations électriques, les énergies renouvelables et les solutions techniques.',
    },

    '/services': {
      title: 'Nos services électriques et énergétiques | GPE',
      description:
        'Découvrez les services de GPE : courants forts, courants faibles, énergies renouvelables, mobilité électrique, rénovation énergétique, CVC, VRD et bureau d’études.',
    },

    '/references': {
      title: 'Nos réalisations | Projets GPE',
      description:
        'Découvrez les réalisations de GPE – Énergies & Services : installations électriques, photovoltaïque, mobilité électrique, infrastructures et projets énergétiques en France.',
    },

    '/international': {
      title: 'GPE à l’international',
      description:
        'GPE – Énergies & Services développe son expertise et accompagne ses clients dans leurs projets énergétiques et électriques à l’international.',
    },

    '/contact': {
      title: 'Contact GPE – Énergies & Services',
      description:
        'Contactez GPE – Énergies & Services pour votre projet d’installation électrique, d’énergie renouvelable, de CVC, de mobilité électrique ou d’infrastructure.',
    },

    '/services/courants-forts': {
      title: 'Courants forts | Installations électriques GPE',
      description:
        'GPE réalise vos installations électriques en courants forts : distribution électrique, tableaux, raccordements et équipements pour bâtiments professionnels et industriels.',
    },

    '/services/courants-faibles': {
      title: 'Courants faibles | Réseaux et sécurité | GPE',
      description:
        'GPE conçoit et installe vos solutions en courants faibles : réseaux, sécurité, communication, contrôle d’accès et infrastructures connectées.',
    },

    '/services/energies-renouvelables': {
      title: 'Énergies renouvelables | Photovoltaïque GPE',
      description:
        'GPE vous accompagne dans vos projets d’énergies renouvelables et d’installations photovoltaïques pour produire une énergie plus durable et maîtriser vos consommations.',
    },

    '/services/mobilite-electrique': {
      title: 'Mobilité électrique | Bornes de recharge IRVE | GPE',
      description:
        'GPE installe des infrastructures de recharge pour véhicules électriques et des bornes IRVE adaptées aux entreprises, parkings et sites professionnels.',
    },

    '/services/renovation-energetique': {
      title: 'Rénovation énergétique | GPE',
      description:
        'GPE accompagne les entreprises dans leurs projets de rénovation énergétique afin d’améliorer la performance, le confort et la maîtrise des consommations.',
    },

    '/services/chauffage-climatisation': {
      title: 'Chauffage et climatisation | GPE',
      description:
        'GPE propose des solutions de chauffage, climatisation et CVC adaptées aux bâtiments professionnels, avec une approche orientée performance énergétique.',
    },

    '/services/vrd': {
      title: 'VRD | Voiries et réseaux divers | GPE',
      description:
        'GPE intervient sur les travaux de voirie et réseaux divers pour accompagner vos projets d’aménagement, d’infrastructures et de réseaux.',
    },

    '/services/bureau-etudes': {
      title: 'Bureau d’études | Ingénierie électrique GPE',
      description:
        'Le bureau d’études GPE conçoit et accompagne vos projets techniques avec des solutions adaptées aux besoins électriques, énergétiques et aux infrastructures.',
    },

    '/mentions-legales': {
      title: 'Mentions légales | GPE',
      description:
        'Consultez les mentions légales du site GPE – Énergies & Services : éditeur, hébergement, propriété intellectuelle, cookies et protection des données.',
    },

    '/politique-de-confidentialite': {
      title: 'Politique de confidentialité | GPE',
      description:
        'Consultez la politique de confidentialité de GPE – Énergies & Services concernant la collecte, l’utilisation et la protection des données personnelles.',
    },

    '/cgv': {
      title: 'Conditions générales de vente | GPE',
      description:
        'Consultez les conditions générales de vente de GPE – Énergies & Services relatives à ses prestations d’installations électriques, énergétiques et techniques.',
    },

    '/thank-you': {
      title: 'Merci | GPE – Énergies & Services',
      description:
        'Merci d’avoir contacté GPE – Énergies & Services.',
    },
  },

  en: {
    '/': {
      title: 'GPE – Energy & Services | Electrical and Renewable Energy',
      description:
        'GPE – Energy & Services supports businesses with electrical installations, renewable energy, HVAC, electric mobility, infrastructure and engineering projects.',
    },

    '/about': {
      title: 'About GPE – Energy & Services',
      description:
        'Discover GPE – Energy & Services, our expertise, teams and know-how in electrical installations, renewable energy and technical solutions.',
    },

    '/services': {
      title: 'Electrical and Energy Services | GPE',
      description:
        'Discover GPE services including high voltage, low voltage, renewable energy, electric mobility, energy renovation, HVAC, VRD and engineering.',
    },

    '/references': {
      title: 'Our Projects | GPE Achievements',
      description:
        'Discover GPE – Energy & Services projects including electrical installations, photovoltaic systems, electric mobility, infrastructure and energy projects in France.',
    },

    '/international': {
      title: 'GPE International',
      description:
        'GPE – Energy & Services provides expertise and support for electrical and energy projects internationally.',
    },

    '/contact': {
      title: 'Contact GPE – Energy & Services',
      description:
        'Contact GPE – Energy & Services about your electrical, renewable energy, HVAC, electric mobility or infrastructure project.',
    },

    '/services/courants-forts': {
      title: 'High Voltage Electrical Installations | GPE',
      description:
        'GPE delivers high voltage electrical installations including power distribution, electrical panels, connections and equipment for professional and industrial buildings.',
    },

    '/services/courants-faibles': {
      title: 'Low Voltage Systems | Networks and Security | GPE',
      description:
        'GPE designs and installs low voltage systems including networks, security, communications, access control and connected infrastructure.',
    },

    '/services/energies-renouvelables': {
      title: 'Renewable Energy | Photovoltaic Solutions | GPE',
      description:
        'GPE supports renewable energy and photovoltaic projects to help businesses produce cleaner energy and control their energy consumption.',
    },

    '/services/mobilite-electrique': {
      title: 'Electric Mobility | EV Charging Stations | GPE',
      description:
        'GPE installs electric vehicle charging infrastructure and EV charging stations for businesses, car parks and professional sites.',
    },

    '/services/renovation-energetique': {
      title: 'Energy Renovation | GPE',
      description:
        'GPE supports businesses with energy renovation projects designed to improve energy performance, comfort and consumption management.',
    },

    '/services/chauffage-climatisation': {
      title: 'Heating and Air Conditioning | GPE',
      description:
        'GPE provides heating, air conditioning and HVAC solutions for professional buildings with a focus on energy performance.',
    },

    '/services/vrd': {
      title: 'VRD | Roads and Utilities | GPE',
      description:
        'GPE provides roads and utilities services for development, infrastructure and network projects.',
    },

    '/services/bureau-etudes': {
      title: 'Engineering Office | Electrical Engineering | GPE',
      description:
        'GPE engineering services support technical projects with solutions adapted to electrical, energy and infrastructure requirements.',
    },

    '/mentions-legales': {
      title: 'Legal Notice | GPE',
      description:
        'Read the legal notice for the GPE – Energy & Services website, including publisher, hosting, intellectual property, cookies and data protection information.',
    },

    '/politique-de-confidentialite': {
      title: 'Privacy Policy | GPE',
      description:
        'Read the GPE – Energy & Services privacy policy covering the collection, use and protection of personal data.',
    },

    '/cgv': {
      title: 'General Terms and Conditions | GPE',
      description:
        'Read the general terms and conditions of sale applicable to GPE – Energy & Services electrical, energy and technical services.',
    },

    '/thank-you': {
      title: 'Thank You | GPE – Energy & Services',
      description:
        'Thank you for contacting GPE – Energy & Services.',
    },
  },

  ar: {
    '/': {
      title: 'GPE – الطاقة والخدمات | التركيبات الكهربائية والطاقة المتجددة',
      description:
        'تقدم GPE – الطاقة والخدمات حلولاً للمؤسسات في مجال التركيبات الكهربائية والطاقة المتجددة والتدفئة والتكييف والتنقل الكهربائي والبنية التحتية والدراسات التقنية.',
    },

    '/about': {
      title: 'من نحن | GPE – الطاقة والخدمات',
      description:
        'اكتشفوا GPE – الطاقة والخدمات وخبراتنا وفرقنا وكفاءاتنا في مجال التركيبات الكهربائية والطاقة المتجددة والحلول التقنية.',
    },

    '/services': {
      title: 'خدماتنا الكهربائية وخدمات الطاقة | GPE',
      description:
        'اكتشفوا خدمات GPE في مجال الكهرباء والطاقة المتجددة والتنقل الكهربائي وتجديد الطاقة والتدفئة والتكييف والبنية التحتية والدراسات الهندسية.',
    },

    '/references': {
      title: 'مشاريعنا وإنجازاتنا | GPE',
      description:
        'اكتشفوا مشاريع وإنجازات GPE في مجال التركيبات الكهربائية والطاقة الشمسية والتنقل الكهربائي والبنية التحتية والطاقة في فرنسا.',
    },

    '/international': {
      title: 'GPE على المستوى الدولي',
      description:
        'تقدم GPE – الطاقة والخدمات خبراتها وترافق عملاءها في مشاريع الكهرباء والطاقة على المستوى الدولي.',
    },

    '/contact': {
      title: 'اتصل بـ GPE – الطاقة والخدمات',
      description:
        'تواصلوا مع GPE – الطاقة والخدمات بخصوص مشاريع التركيبات الكهربائية والطاقة المتجددة والتدفئة والتكييف والتنقل الكهربائي والبنية التحتية.',
    },

    '/services/courants-forts': {
      title: 'التيار القوي | التركيبات الكهربائية | GPE',
      description:
        'تنفذ GPE التركيبات الكهربائية للتيار القوي بما في ذلك توزيع الكهرباء واللوحات والتوصيلات والمعدات للمباني المهنية والصناعية.',
    },

    '/services/courants-faibles': {
      title: 'التيار الضعيف | الشبكات والأمن | GPE',
      description:
        'تصمم GPE حلول التيار الضعيف وتنفذها، بما في ذلك الشبكات والأمن والاتصالات والتحكم في الدخول والبنية التحتية المتصلة.',
    },

    '/services/energies-renouvelables': {
      title: 'الطاقة المتجددة | الطاقة الشمسية | GPE',
      description:
        'ترافق GPE مشاريع الطاقة المتجددة والطاقة الشمسية لمساعدة المؤسسات على إنتاج طاقة أكثر استدامة والتحكم في استهلاكها.',
    },

    '/services/mobilite-electrique': {
      title: 'التنقل الكهربائي | محطات شحن السيارات | GPE',
      description:
        'تقوم GPE بتركيب البنية التحتية ومحطات شحن السيارات الكهربائية للشركات ومواقف السيارات والمواقع المهنية.',
    },

    '/services/renovation-energetique': {
      title: 'تجديد الطاقة وتحسين كفاءة المباني | GPE',
      description:
        'ترافق GPE المؤسسات في مشاريع تجديد الطاقة لتحسين الأداء الطاقي والراحة والتحكم في استهلاك الطاقة.',
    },

    '/services/chauffage-climatisation': {
      title: 'التدفئة والتكييف | GPE',
      description:
        'تقدم GPE حلول التدفئة والتكييف وأنظمة HVAC للمباني المهنية مع التركيز على كفاءة الطاقة.',
    },

    '/services/vrd': {
      title: 'الطرق والشبكات المختلفة | GPE',
      description:
        'تتدخل GPE في أعمال الطرق والشبكات المختلفة لدعم مشاريع التطوير والبنية التحتية والشبكات.',
    },

    '/services/bureau-etudes': {
      title: 'مكتب الدراسات والهندسة الكهربائية | GPE',
      description:
        'يدعم مكتب الدراسات في GPE المشاريع التقنية من خلال حلول مناسبة للاحتياجات الكهربائية والطاقة والبنية التحتية.',
    },

    '/mentions-legales': {
      title: 'الإشعارات القانونية | GPE',
      description:
        'اطلعوا على المعلومات القانونية الخاصة بموقع GPE – الطاقة والخدمات، بما في ذلك الناشر والاستضافة والملكية الفكرية وملفات تعريف الارتباط وحماية البيانات.',
    },

    '/politique-de-confidentialite': {
      title: 'سياسة الخصوصية | GPE',
      description:
        'اطلعوا على سياسة الخصوصية الخاصة بـ GPE – الطاقة والخدمات والمتعلقة بجمع البيانات الشخصية واستخدامها وحمايتها.',
    },

    '/cgv': {
      title: 'الشروط والأحكام العامة للبيع | GPE',
      description:
        'اطلعوا على الشروط والأحكام العامة للبيع الخاصة بخدمات GPE – الطاقة والخدمات في المجالات الكهربائية والطاقة والخدمات التقنية.',
    },

    '/thank-you': {
      title: 'شكراً لكم | GPE – الطاقة والخدمات',
      description:
        'شكراً لتواصلكم مع GPE – الطاقة والخدمات.',
    },
  },
};

export default seo;
